"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var PlanInformation = function PlanInformation(_ref) {
  var loanAmount = _ref.loanAmount,
    payment = _ref.payment,
    term = _ref.term,
    rate = _ref.rate,
    formatNumberWithComma = _ref.formatNumberWithComma;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", {
    "data-test-id": "plan-type",
    className: "plan-info-header"
  }, "Plan Information:"), /*#__PURE__*/_react.default.createElement("div", {
    className: "plan-info"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "plan-info-labels"
  }, /*#__PURE__*/_react.default.createElement("label", {
    "data-test-id": "loan-amount",
    className: "plan-info-label applicant-loan-amt-label"
  }, "Amount financed:"), /*#__PURE__*/_react.default.createElement("label", {
    "data-test-id": "loan-payment",
    className: "plan-info-label applicant-loan-payment-label"
  }, "Monthly payment:"), /*#__PURE__*/_react.default.createElement("label", {
    "data-test-id": "loan-term",
    className: "plan-info-label applicant-loan-term-label"
  }, "Number of payments:"), /*#__PURE__*/_react.default.createElement("label", {
    "data-test-id": "apr",
    className: "plan-info-label applicant-loan-apr-label"
  }, "Annual percentage rate:")), /*#__PURE__*/_react.default.createElement("div", {
    className: "plan-info-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "plan-info-data applicant-loan-amt"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "applicant-loan-amt-data"
  }, '$' + formatNumberWithComma(Math.trunc(loanAmount)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "plan-info-data applicant-loan-payment"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "applicant-loan-payment-data"
  }, '$' + formatNumberWithComma(payment.toFixed(2)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "plan-info-data applicant-loan-term"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "applicant-loan-term"
  }, term)), /*#__PURE__*/_react.default.createElement("div", {
    className: "plan-info-data applicant-loan-apr"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "applicant-loan-apr-data"
  }, (rate * 100).toFixed(2), "%")))));
};
PlanInformation.propTypes = {
  loanAmount: _propTypes.default.number.isRequired,
  payment: _propTypes.default.number.isRequired,
  term: _propTypes.default.number.isRequired,
  rate: _propTypes.default.number.isRequired,
  formatNumberWithComma: _propTypes.default.func.isRequired
};
var _default = PlanInformation;
exports.default = _default;
